import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class DeleteSpeakerService {
  deleteSpeakerURL: string;
  constructor(private http: HttpClient) {
    this.deleteSpeakerURL = environment.baseURI + environment.apiUrl + 'speaker/update';
  }

  deleteSpeaker(obj) {
    return this.http.post(this.deleteSpeakerURL, obj);
  }
}
